<template>
  <div class="introduction">
    <h2>
      <span>安邦</span>简介
    </h2>
    <p class="font14">安邦制药于2001年设立专门的新药研发中心，专注于中医药优势领域大病种药物研发，主要承担集团及下属分公司创新药物及健康产品的研发及学术提升、中药新技术的应用和研究、知识产权管理、项目申报等工作。现拥有集省级院士专家工作站、省级经典名方工程技术研究中心、省级技术中心、省海智基地、省研究生创新创业平台于一体的中药创新科研平台以及食品药品中试及产业转化基地。2001年～至今，连续十八年获评“高新技术企业”，并被评为国家火炬计划重点高新技术企业。</p>
    <p class="font14">1、人员及硬件设施情况</p>
    <p class="font14">目前共有研究人员60名，期中中高级以上职称人数51人。中心建有2000 多平方米的标准实验室，拥有如液质联用、核磁共振、原子吸收、气相、紫外、红外、喷雾干燥及成套的中试实验设备（含提取、浓缩、柱层析等）等一系列先进仪器设备。</p>
    <p class="font14">2、产品开发</p>
    <p class="font14">安邦制药注重自主创新，每年用于新药研发的费用始终稳定在销售收入的5%左右。自成立以来，共研究立项59项，其中已获批医药产品批准文号33个，临床研究批件3个，在研项目17个。近年来，公司对27项科技成果进行了转化，成果转化成功率82%。</p>
    <p class="font14">3、产学研合作</p>
    <p class="font14">2015年6月与湖南中医药大学校企合作研究生创新创业基地，成为我省药学领域技术创新、成果孵化与转化基地。2015年8月，与中国中医科学院王永炎院士团队共建院士专家工作站，专注中药大品种培育研究。2017年与湖南省食品药品职业学院校企合作产业化平台，目前已获得保健食品生产许可以及固体饮料、压片糖果生产许可，可承接各类产品个性化定制服务。同年与巴基斯坦卡拉奇大学国际化学和生物科学研究中心建立战略合作，探索建立中巴中医药民族医药评价体系；2019年5月共建中巴中医药临床研究中心，开启中医药国际化新篇章。</p>
  </div>
</template>

<script>
export default {
  name: "intruduction"
};
</script>

<style lang="stylus">
.introduction {
  h2 {
    font-weight: normal;
    margin-bottom: 12px;
    color: #ED822A;
    font-size: 36px;

    span {
      color: #1278C6;
    }
  }

  .in_right {
    padding-left: 20px;
    margin-bottom: 49px;
  }

  p {
    line-height: 30px;
  }
}
</style>